import React, { useId } from "react";

import Card from "../../Card";
import Definitions from "../../Definitions";
import CouponCashFlowChart from "../CouponCashFlowReport/CouponCashFlowChart";
import PortfolioCharacteristicsDataTable from "../PortfolioCharacteristicsReport/PortfolioCharacteristicsDataTable";
import SectorsChart from "../SectorsReport/SectorsChart";

import useOutputReportStore from "../../../store/OutputReport.store";
import { getOutputType } from "../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../utils/resources/dataTableCopy";
import { equityDefinitions } from "../../../utils/resources/definitionsCopy";
import {
  portfolioObjectiveCopy,
  whyRemiCopy,
} from "../../../utils/resources/oneSheeterCopy";

const OneSheeterReportCash = () => {
  const cardId1 = useId();
  const cardId2 = useId();
  const cardId3 = useId();
  const cardId4 = useId();

  const data = useOutputReportStore((state) => state.data);
  const { assetType } = getOutputType(data);
  const isEquityReport = assetType === "equity";

  const portfolioCharacteristicsRows = {
    equity: [
      "Number of Securities****",
      "Tracking Error to Benchmark",
      "% of Market Value in Stocks",
      "Beta to Benchmark",
      "Dividend Yield",
    ],
    default: [
      "Effective Duration (OAD)",
      "Yield to Maturity [3]",
      "Yield to Worst [3]",
      "Credit Quality",
      "Price",
    ],
  };

  const footnotes = {
    equity: (
      <>
        {dataTableCopy.unlessOtherwiseStated}
        <br />
        [1]{dataTableCopy.sectorExposure}
        <br />
        [2]{dataTableCopy.targetPortfolios}
        <br />
        [3]{dataTableCopy.seeBenchmark}
      </>
    ),
  };

  const definitionsArgs = {
    className: "report-article",
    isHeadingHidden: true,
    bodyContent: [
      {
        footnoteContent: footnotes.equity,
      },
    ],
    footnote: equityDefinitions.footnote,
  };

  return (
    <>
      <section className="report-article__visual">
        <Card
          id={cardId1}
          openByDefault={true}
          title={
            isEquityReport ? "Investment Objective" : "Portfolio Objective"
          }
        >
          {portfolioObjectiveCopy[assetType]}
        </Card>
      </section>
      <section className="report-article__visual print-break-after">
        <Card id={cardId2} openByDefault={true} title="Why Remi?">
          {whyRemiCopy}
        </Card>
      </section>
      {data?.["Portfolio Characteristics"] && (
        <section className="report-article__visual one-sheeter__table print-break-after">
          <Card
            id={cardId3}
            openByDefault={true}
            title={
              isEquityReport
                ? "Portfolio Characteristics"
                : "Portfolio Breakdown"
            }
          >
            <PortfolioCharacteristicsDataTable
              name={
                isEquityReport
                  ? "portfolioCharacteristics-ose"
                  : "portfolioCharacteristics-os"
              }
              visibleRows={
                isEquityReport
                  ? portfolioCharacteristicsRows.equity
                  : portfolioCharacteristicsRows.default
              }
            />
          </Card>
        </section>
      )}
      {!isEquityReport &&
        data?.["Cash Flow Profile"] &&
        assetType !== "tbill" && (
          <section className="report-article__visual one-sheeter__chart">
            <Card id={cardId4} openByDefault={true} title="Coupon Cash Flow">
              <CouponCashFlowChart
                id="one-sheeter-coupon-cash-flow"
                isFullWidth={false}
              />
            </Card>
          </section>
        )}

      {isEquityReport && data?.["Sectors (GICS)"] && (
        <>
          <section className="report-article__visual one-sheeter__chart">
            <Card id={cardId4} openByDefault={true} title="Sectors (GICS®)">
              <div className="one-sheeter__chart-container">
                <SectorsChart
                  id="one-sheeter-sector-gics"
                  isFullWidth={true}
                  reportName="Sectors (GICS)"
                  name="sectors-gics-ose"
                />
              </div>
            </Card>
          </section>

          <section className="report-article__visual one-sheeter__footnotes">
            <Definitions {...definitionsArgs} />
          </section>
        </>
      )}
    </>
  );
};

export default OneSheeterReportCash;
